export default {
    // 报警级别信息查询接口
    getAlarmLevel(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/getAlarmLevel', params, response);
    },
    // 报警级别信息添加接口
    saveAlarmLevel(params, response) {
        if (params.sId == '') {
            window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/addAlarmLevel', JSON.stringify(params), response);
        } else {
            window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/updateAlarmLevel', JSON.stringify(params), response);
        }
    },
    // 报警级别信息删除接口
    deleteAlarmLevel(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/deleteAlarmLevel', params, response);
    },
    // 校验名称是否重复
    checkRepeat(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/checkAlarmLevelRepeat', JSON.stringify(params), response);
    }
};
